import styled from 'styled-components'

export const HeroWrapper = styled.div`
  background-color: ${({ bgColor }) => bgColor};
  display: flex;
  position: relative;
  justify-content: center;
  > div > div {
    background-color: transparent;
  }
  ${({ showOverflow }) => (showOverflow ? '' : 'overflow: hidden;')}
`

export const InnerContent = styled.div`
  display: flex;
  width: 100%;
  max-width: ${({ innerMax }) => (innerMax ? innerMax : '1400px')};

  justify-content: space-between;
  @media only screen and (max-width: ${({ breakP }) =>
      breakP ? breakP : '890px'}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export const GraphicWrapper = styled.div`
  display: flex;
  z-index: 5;
  max-width: ${({ max }) => (max ? max : '800px')};
  margin: ${({ pad }) => (pad ? pad : '0')};
  width: 100%;
  > div {
    width: 100%;
  }
  @media only screen and (max-width: ${({ breakP }) =>
      breakP ? breakP : '890px'}) {
    justify-content: center;
    padding: 0 1.8rem 0;
    box-sizing: border-box;
    ${({ imgMobileMargin }) => `margin: ${imgMobileMargin}`};
  }
`

export const TextWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  z-index: 6;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ textPad }) => (textPad ? textPad : '4rem 0 2rem 1.8rem')};

  > div {
    max-width: ${({ headMax }) => headMax || `500px`};
    padding: 0;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media only screen and (max-width: 950px) {
    > div > h2 {
      font-size: 36px;
    }
  }

  @media only screen and (max-width: ${({ breakP }) =>
      breakP ? breakP : '890px'}) {
    width: 100%;
    align-items: center;
    > div {
      align-items: center;
      text-align: center;
      justify-content: center;
    }
    padding-bottom: 4rem;
    padding-top: 8rem;
    padding-right: 1.8rem;
  }

  @media only screen and (max-width: 550px) {
    > div > h2 {
      font-size: 30px;
    }
  }
`

export const ButtonWrapper = styled.div`
  padding: 2rem 0 0 0 !important;
  box-sizing: border-box;
  display: flex;
  width: 100%;
`

export const BottomBar = styled.div`
  justify-content: center;
  align-items: center;
  width: 100%;
  white-space: pre;
  min-height: 60px;
  position: relative;
  z-index: 10;
  transform: translateY(-4px);
  ${({ barMargin }) => barMargin && `margin: ${barMargin}`}
  ${({ barPad }) => barPad && `padding: ${barPad}`};
  background-image: linear-gradient(to right, #cb206a 0%, #9040d5 100%);
  display: none;
  @media only screen and (max-width: ${({ breakP }) =>
      breakP ? breakP : '890px'}) {
    display: flex;
  }
  color: white;
  > a,
  p {
    color: white;
    font-size: 1.2rem;
  }
`

export const Vector = styled.div`
  ${({ breakP }) => (breakP ? `display: none` : `display: block`)};
  @media only screen and (min-width: ${({ breakP }) =>
      breakP ? breakP : '890px'}) {
    display: block;
  }
`

export const MobileGraphic = styled.div`
  display: none;
  @media only screen and (max-width: ${({ breakP }) =>
      breakP ? breakP : '890px'}) {
    display: block;
  }
`
